import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Top bar — visible on mobile only (hamburger to open the sidebar drawer).
 * On desktop (lg+) it is hidden; the sidebar itself carries all user controls.
 */
export default function AdminTopbar({ onOpenSidebar }) {
  return (
    <header className='flex h-14 shrink-0 items-center border-b border-border bg-background px-4 lg:hidden'>
      <Button
        type='button'
        variant='ghost'
        size='icon'
        onClick={onOpenSidebar}
        aria-label='Abrir menú'
      >
        <Menu className='h-5 w-5' />
      </Button>
      <span className='ml-3 text-sm font-semibold text-foreground'>gotalottery</span>
    </header>
  );
}
